import { getGenericError } from './errors';

import {
  EARNINGS_SUMMARY_PATH,
  EARNINGS_TRANSACTIONS_PATH,
  EVENT_STREAM_PATH,
  EVENT_STREAM_EVENT_TYPES,
  EVENT_STREAM_APP_TYPES,
  SUSTAINABILITY_IMPACT_USER_PATH,
  REWARDS_PATH,
  REWARD_ID_PARAM,
  REWARDS_CLAIM_PATH,
  REWARDS_USED_PATH,
  STORE_ID_PARAM,
  STORE_PATH,
  REWARDS_USER_PATH,
  REWARDS_OFFER_PATH,
  CONFIGURATION_PATH,
  REWARDS_STORE_PATH,
  CLOSET_CASH_DISCOUNT_CODES_PATH,
  SHOPIFY_STORE_PARAM,
  SHOPIFY_STORES,
  CLOSET_CASH_DISCOUNT_CODE_CLAIM_PATH,
  DISCOUNT_CODE_ID_PARAM,
  REGENERATION_SHIPPING_LABEL_PATH,
  REDEMPTION_CODE_PARAM,
  TBB_SHIPPING_LABELS_PATH,
  TBB_INSTANT_LABELS_AVAILABLE_PATH,
  BATCH_ID_PARAM,
  ITEM_ID_PARAM,
  REDEMPTIONS_BULK_CREATE_PATH,
  REDEMPTIONS_BULK_PATH,
  REDEMPTIONS_VALIDATE_PATH,
  REDEMPTIONS_BULK_ITEM_RETRY_PATH,
  SHIPPING_LABELS_WALLET_PASSES_BULK_PATH,
  CATEGORIES_PATH,
  EARNINGS_CAROUSEL_PATH,
  USERS_ADDRESSES_PATH,
  USERS_STATUS_PATH,
  REFERRALS_ME_PATH,
  SEND_SIGN_IN_EMAIL_LINK_PATH,
  SHIPPING_PROVIDERS_PATH,
  SUBSCRIBE_PATH,
  REDEMPTIONS_PATH,
  GIFT_CARDS_BRANDS_PATH,
  GIFT_CARDS_CATEGORIES_PATH,
  GIFT_CARDS_BRAND_PATH,
  GIFT_CARDS_BRAND_SEARCH_PATH,
  BRAND_ID_PARAM,
  GIFT_CARDS_ISSUE_PATH,
  GIFT_CARD_ID_PARAM,
  GIFT_CARD_BY_UID_PATH,
  GIFT_CARDS_USER_PATH,
  GIFT_CARDS_USED_PATH,
  GIFT_CARDS_WALLET_PASS_PATH,
  AUTH_USERS_PATH,
  SIMILAR_AND_TRENDING_REWARDS_PATH,
  FEATURED_REWARDS_PATH,
  SYSTEM_MESSAGES_PATH,
  PAYMENTS_CREATE_PAY_ON_REG_CHECKOUT_SESSION_PATH,
  PAYMENTS_STATUS_PATH,
  PAYMENTS_CREATE_SETUP_INTENT_PATH,
  REWARDS_EXCLUSIVE_PATH,
  GIFT_CARDS_BRANDS_OFFER_PATH,
  REWARDS_USER_EXCLUSIVE_DEALS_PATH,
  EVENT_TICKETS_COUNT_PATH,
  EVENT_TICKETS_CLAIM_PATH,
  EVENT_ID_PARAM,
  BROWN_UNIVERSITY_EVENT_ID,
  MARKETING_ITERABLE_SUBSCRIPTION_PATH,
  REWARDS_PAID_PLACEMENTS_PATH,
  USERS_MEMBERSHIP_ADDRESSES_PATH,
  USERS_MILESTONE_PROGRESS_PATH,
  USERS_CREATE_ADDRESS_PATH,
  ADDRESS_UID_PARAM,
  USERS_UPDATE_ADDRESS_PATH,
  SUBSCRIPTIONS_CLAIM_TBB_PATH,
  SUBSCRIPTIONS_CREATE_CHECKOUT_SESSION_PATH,
  SUBSCRIPTIONS_CREATE_SHOPIFY_CHECKOUT_PATH,
  SUBSCRIPTIONS_MEMBERSHIP_STATUS_PATH,
  SUBSCRIPTIONS_TOY_BOX_UPGRADE_CHECKOUT_PATH,
  SUBSCRIPTIONS_MEMBERSHIP_SHIPPING_CHECKOUT_PATH,
  SUBSCRIPTIONS_MEMBERSHIP_SHIPPING_STATUS_PATH,
  SUBSCRIPTIONS_MEMBERSHIP_SHIPPING_CANCEL_PATH,
  SUBSCRIPTIONS_UPDATE_PAYMENT_URL_PATH,
  SUBSCRIPTIONS_ORDERS_PATH,
  SUBSCRIPTIONS_ORDERS_SUMMARY_PATH,
  SUBSCRIPTIONS_PATH,
  SUBSCRIPTION_ID_PARAM,
  SUBSCRIPTIONS_CANCEL_PATH,
  SUBSCRIPTIONS_RESUME_AUTO_RENEW_PATH,
  SUBSCRIPTIONS_RENEWAL_STATUS_PATH,
  SUBSCRIPTIONS_WINBACK_STRIPE_QUOTE_PATH,
  SUBSCRIPTIONS_WINBACK_STRIPE_RENEW_PATH,
  SUBSCRIPTIONS_SAVE_OFFER_PATH,
  SUBSCRIPTIONS_ACCEPT_SAVE_OFFER_PATH,
  SUBSCRIPTIONS_UPDATE_PATH,
  CHECKOUT_SESSION_ID_PARAM,
  SUBSCRIPTIONS_CHECKOUT_SESSION_PATH,
  MEMBERSHIP_PRODUCTS_PRICES_PATH,
  PARTNER_PATH,
  PARTNER_ID_PARAM,
  SAVED_MONEY_PATH,
  PAYMENTS_CREATE_PAYMENT_INTENT_PATH,
  PAYMENTS_ORDER_CHECKOUT_SESSION_PATH,
  MEMBERSHIP_VALIDATE_SHIPPING_PATH,
  SUBSCRIPTIONS_PLANS_PATH,
  PAYMENTS_ORDER_CREATE_CHECKOUT_SESSION_PATH,
  FEDEX_LOCATIONS_PATH,
  FEDEX_GROUND_LOCATIONS_PATH,
  THE_RETURN_LOCATIONS_PATH,
  GOLOCKER_LOCATIONS_PATH,
  AMAZON_SHIPPING_LOCATIONS_PATH,
  REWARDS_STORE_PATH_PUBLIC,
  AUTH_PHONE_VERIFY_PATH,
  AUTH_PHONE_PATH,
  AUTH_PHONE_LOGIN_PATH,
  AUTH_MFA_ENABLE_PATH,
  AUTH_MFA_STEP_UP_PATH,
  AUTH_SECURITY_CODE_PATH,
  SEND_EMAIL_VERIFICATION_PATH,
  SEND_PASSWORD_RESET_EMAIL_PATH,
  FORCE_RESET_PASSWORD_PATH,
} from '../config/service';

import crud, { apiFetch } from '../../../api/crud';
import { REWARD_PREVIEW_TYPES } from '../config/rewards';
import { US_COUNTRY_CODE } from './locations';
import { isProd } from '../../../config/config';
import { TRASHIE_GA_TAG_ID } from '../config/config';
import { getStoredUtms, getFirstTouchAttribution, getReferrerOrigin } from './url';
import { getStoredPartnerRef } from './partner';
import { getStoredReferralCode } from './referralAttribution';

const get = async ({ path, options, params }) => {
  const queryString = new URLSearchParams({
    ...(options ? { options: JSON.stringify(options) } : {}),
    ...params,
  }).toString();

  const pathString = queryString ? `${path}?${queryString}` : path;

  const data = await apiFetch({ path: pathString });

  return data;
};

const post = async ({ path, body, authToken }) => {
  const data = await apiFetch({ path, body: JSON.stringify(body), method: 'POST', authToken });

  return data;
};

const serializeSearchParams = (searchParams) => {
  if (!searchParams) return undefined;

  try {
    return Object.fromEntries(searchParams);
  } catch {
    return undefined;
  }
};

// TODO: Uncomment this once we have a PUT endpoint
// const put = async ({ path, body }) => {
//   const data = await apiFetch({ path, body: JSON.stringify(body), method: 'PUT' });

//   return data;
// };

const patch = async ({ path, body }) => {
  const data = await apiFetch({ path, body: JSON.stringify(body), method: 'PATCH' });

  return data;
};

const checkResponseError = (response) => {
  const { status, error } = response;
  let errorMessage = { message: getGenericError() };

  if (status > 202) {
    if (error) {
      // Envelope bodies nest the error; flat ones (e.g. the MFA middleware's
      // `{ status, code, message }`) arrive as `error: true` from apiFetch.
      const { code, message, details } = typeof error === 'object' ? error : response;

      errorMessage = { code, message: message || getGenericError(), details };
    }
  }

  return errorMessage;
};

const wait = (delay) => new Promise((resolve) => { setTimeout(resolve, delay); });

const withRetry = async (
  requestFn,
  tries = 3,
  waitTime = 500,
  onCheckError = () => false,
) => {
  try {
    const response = await requestFn();

    if (tries > 1 && onCheckError(response)) {
      return wait(waitTime).then(() => withRetry(requestFn, tries - 1, waitTime, onCheckError));
    }

    return response;
  } catch (err) {
    if (tries <= 1) {
      throw err;
    }

    return wait(waitTime).then(() => withRetry(requestFn, tries - 1, waitTime, onCheckError));
  }
};

const getWithRetry = (
  { path, options, params },
  tries = 3,
  waitTime = 500,
  onCheckError = () => false,
) => withRetry(() => get({ path, options, params }), tries, waitTime, onCheckError);

const getUser = async (uid) => {
  let data = [];
  let error = '';

  try {
    data = await crud.get({
      path: '/users',
      options: {
        where: {
          uid,
        },
      },
    });
  } catch ({ message }) {
    error = message;
  }

  return { data: data[0] ?? null, error };
};

const getSummary = async () => {
  let data = {};
  let error = '';

  try {
    const response = await get({
      path: EARNINGS_SUMMARY_PATH,
    });

    data = response.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data, error };
};

const getTransactions = async () => {
  let data = [];
  let error = '';

  try {
    const response = await get({
      path: EARNINGS_TRANSACTIONS_PATH,
    });

    data = response.data ?? [];
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data, error };
};

const sendEventStream = async ({
  event = EVENT_STREAM_EVENT_TYPES.USER_REGISTERED,
  application = EVENT_STREAM_APP_TYPES.TRASHIE,
  data = {},
}) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: EVENT_STREAM_PATH,
      body: {
        event,
        application,
        data,
      },
    });

    responseData = response.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const syncUser = async (uid, email) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: '/users',
      body: {
        data: {
          email,
          uid,
          meta: {
            migrated: false,
            application: EVENT_STREAM_APP_TYPES.TRASHIE,
          },
        },
      },
    });

    responseData = response?.createData ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const createOrFetchUser = async (email, method, shouldSubscribe = true, additionalData = {}) => {
  let responseData = {};
  let error = '';
  const originUrl = getReferrerOrigin();

  try {
    const response = await post({
      path: AUTH_USERS_PATH,
      body:
        {
          firstName: '',
          lastName: '',
          email,
          data: {
            shouldSubscribe,
            method,
            originUrl,
            ...additionalData,
          },

        },
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }
  return { data: responseData, error };
};

const updateUser = async ({ firstName, lastName, forcePwdReset }) => {
  let responseData = {};
  let error = '';

  try {
    const response = await patch({
      path: '/users',
      body: {
        data: {
          firstName,
          lastName,
          forcePwdReset,
        },
      },
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const getSustainabilityImpactUser = async () => {
  let responseData = [];
  let error = '';

  try {
    const response = await get({
      path: SUSTAINABILITY_IMPACT_USER_PATH,
    });

    responseData = response?.data ?? [];
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const getSimilarAndTrendingRewards = async ({ pageSize, page, isHot, rewardId, ...rest }) => {
  let responseData = [];
  let error = '';
  const queryParams = isHot ? { isHot: true } : {};

  try {
    const response = await get({
      path: SIMILAR_AND_TRENDING_REWARDS_PATH,
      params: {
        pageSize,
        page,
        rewardId,
        ...queryParams,
        ...rest,
      },
    });

    responseData = response?.data ?? [];
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const getFeaturedRewards = async (rest) => {
  let responseData = [];
  let error = '';

  try {
    const response = await get({
      path: FEATURED_REWARDS_PATH,
      params: rest,
    });

    responseData = response?.data ?? [];
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const getUserExclusiveDeals = async ({ pageSize, page, ...rest }) => {
  let responseData = [];
  let error = '';

  try {
    const response = await get({
      path: REWARDS_USER_EXCLUSIVE_DEALS_PATH,
      params: {
        pageSize,
        page,
        ...rest,
      },
    });

    responseData = response?.data ?? [];
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const getRewards = async ({
  pageSize,
  page,
  type = REWARD_PREVIEW_TYPES.DEFAULT,
  ...rest
}) => {
  let responseData = [];
  let error = '';

  if ([REWARD_PREVIEW_TYPES.SIMILAR, REWARD_PREVIEW_TYPES.TRENDING].includes(type)) {
    return getSimilarAndTrendingRewards({ pageSize, page, ...rest });
  }

  if (type === REWARD_PREVIEW_TYPES.FEATURED) {
    return getFeaturedRewards({ ...rest });
  }

  if (type === REWARD_PREVIEW_TYPES.EXCLUSIVE) {
    return getUserExclusiveDeals({ pageSize, page, ...rest });
  }

  try {
    const response = await get({
      path: REWARDS_PATH,
      params: {
        pageSize,
        page,
        ...rest,
      },
    });

    responseData = response?.data ?? [];
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const getRewardsOffer = async ({ pageSize, page, ...rest }) => {
  let responseData = [];
  let error = '';

  try {
    const response = await get({
      path: REWARDS_OFFER_PATH,
      params: {
        pageSize,
        page,
        ...rest,
      },
    });

    responseData = response?.data ?? [];
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const getRewardsPaidPlacements = async ({ pageSize, page, ...rest }) => {
  let responseData = [];
  let error = '';

  try {
    const response = await get({
      path: REWARDS_PAID_PLACEMENTS_PATH,
      params: {
        pageSize,
        page,
        ...rest,
      },
    });

    responseData = response?.data ?? [];
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const patchRewardCodeIsUsed = async ({
  rewardId,
  isUsed,
}) => {
  let responseData = {};
  let error = '';

  try {
    const response = await patch({
      path: REWARDS_USED_PATH.replace(REWARD_ID_PARAM, rewardId),
      body: { isUsed },
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const patchGiftCardsIsUsed = async ({
  giftCardsId,
  isUsed,
}) => {
  let responseData = {};
  let error = '';

  try {
    const response = await patch({
      path: GIFT_CARDS_USED_PATH.replace(GIFT_CARD_ID_PARAM, giftCardsId),
      body: { isUsed },
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const getUserRewards = async ({
  pageSize,
  page,
  orderBy,
  orderType,
  type,
  status,
}) => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({
      path: REWARDS_USER_PATH,
      params: {
        pageSize,
        page,
        orderBy,
        orderType,
        type,
        status,
      },
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const getUserAddresses = async ({
  pageSize,
}) => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({
      path: USERS_ADDRESSES_PATH,
      params: {
        pageSize,
      },
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const getMilestoneProgress = async () => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({
      path: USERS_MILESTONE_PROGRESS_PATH,
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const getReferralDashboard = async () => {
  let responseData = null;
  let error = '';
  // A 404 means the user has no link and the program isn't open — the caller
  // should hide the referral surfaces entirely (not surface an error).
  let notFound = false;

  try {
    const response = await get({
      path: REFERRALS_ME_PATH,
    });

    responseData = response?.data ?? null;
  } catch (err) {
    if (err?.status === 404) {
      notFound = true;
    } else {
      error = checkResponseError(err);
    }
  }

  return {
    data: responseData,
    error,
    notFound,
  };
};

const getUserStatus = async (email, phone, countryCode) => {
  let responseData = {};
  let error = '';

  try {
    const params = {};
    if (email) params.email = email;
    if (phone) params.phone = phone;
    if (countryCode) params.countryCode = countryCode;

    const response = await get({
      path: USERS_STATUS_PATH,
      params,
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const getStoreRewards = async (storeId, isPublic = false) => {
  let responseData = [];
  let error = '';

  try {
    const response = await get({
      path: (isPublic ? REWARDS_STORE_PATH_PUBLIC : REWARDS_STORE_PATH)
        .replace(STORE_ID_PARAM, storeId),
    });

    responseData = response?.data ?? [];
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const patchReward = async (rewardId, wfReturnUrl) => {
  let responseData = {};
  let error = null;

  try {
    const response = await patch({
      path: REWARDS_CLAIM_PATH.replace(REWARD_ID_PARAM, rewardId),
      ...(wfReturnUrl && { body: { wfReturnUrl } }),
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const getStore = async (storeId) => {
  let data = [];
  let error = '';

  try {
    data = await crud.get({
      path: STORE_PATH.replace(STORE_ID_PARAM, storeId),
    });
  } catch ({ message }) {
    error = message;
  }

  return { data, error };
};

const getConfigurations = async (property) => {
  let error = '';
  let valueResponse;
  try {
    const { value } = await crud.get({ path: `${CONFIGURATION_PATH}/${property}` });
    valueResponse = value;
  } catch (err) {
    error = err;
  }

  return { value: valueResponse, error };
};

const getCCDiscountCodes = async (
  shop = SHOPIFY_STORES.CLOSET_CASH_STORE,
  maxAmount = 0,
) => {
  let responseData = [];
  let error = '';

  try {
    const response = await get({
      path: CLOSET_CASH_DISCOUNT_CODES_PATH.replace(SHOPIFY_STORE_PARAM, shop),
      params: { maxAmount },
    });

    responseData = response?.data ?? [];
  } catch ({ message }) {
    error = message;
  }

  return {
    data: responseData,
    error,
  };
};

const postCCDiscountCode = async (
  discountCodeId,
  shop = SHOPIFY_STORES.CLOSET_CASH_STORE,
) => {
  let responseData = {};
  let error = null;

  try {
    const response = await post({
      path: CLOSET_CASH_DISCOUNT_CODE_CLAIM_PATH
        .replace(SHOPIFY_STORE_PARAM, shop)
        .replace(DISCOUNT_CODE_ID_PARAM, discountCodeId),
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const postShippingLabelRegenerate = async ({ redemptionCode, shippingMethodId = null }) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: REGENERATION_SHIPPING_LABEL_PATH.replace(REDEMPTION_CODE_PARAM, redemptionCode),
      body: { shippingMethodId },
    });
    if (response.error) {
      error = response.error;
    }
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const getCategories = async ({ ...filters } = {}) => {
  let responseData = {};
  let error = '';
  try {
    const response = await get({
      path: CATEGORIES_PATH,
      params: {
        ...filters,
      },
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const getEarningsCarousel = async () => {
  let responseData = [];
  let error = '';

  try {
    const response = await get({
      path: EARNINGS_CAROUSEL_PATH,
    });

    responseData = response?.data ?? [];
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const postSubscribeStatus = async (email, shouldSubscribe = false) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: SUBSCRIBE_PATH,
      body: {
        email,
        shouldSubscribe,
      },
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const fetchShippingProviders = async ({
  storeUid,
  storeId,
  recyclingProductType,
  provinceCode,
  fromAddress,
}) => {
  let responseData = [];
  let isFarFromFedexDropoff = false;
  let error = '';

  try {
    const response = await post({
      path: SHIPPING_PROVIDERS_PATH,
      body: {
        storeUid,
        storeId,
        recyclingProductType,
        provinceCode,
        // Drives The Return's proximity gate on the BE: it only offers the
        // method when a drop-off is within range of this address. Other
        // providers ignore it.
        fromAddress,
      },
    });

    // api-fordays-cloud#2049 moved this endpoint from a bare array to
    // `{ providers, isFarFromFedexDropoff }`. Accept both: the frontend and the
    // API deploy independently, so either shape can be live at any moment, and
    // reading only the new one would empty the carrier list during the skew.
    const payload = response?.data;

    if (Array.isArray(payload)) {
      responseData = payload;
    } else if (payload && Array.isArray(payload.providers)) {
      responseData = payload.providers;
      isFarFromFedexDropoff = Boolean(payload.isFarFromFedexDropoff);
    } else {
      // Neither shape. Surfacing this as an error matters now that zero
      // providers is a MEANINGFUL answer — without it a broken response renders
      // as "No carriers close by", presenting a parse failure to the user as a
      // confirmed fact about their address.
      error = 'Unrecognized shipping-providers response.';
    }
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    // Always an array, so callers never branch on the wire shape.
    data: responseData,
    // BE reports the customer is >5mi from the nearest FedEx drop-off, for the
    // distance disclaimer. Reporting only — it never changes the list.
    isFarFromFedexDropoff,
    error,
  };
};

const sendSignInEmailLink = async ({
  email,
  returnUrl,
  data,
}) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: SEND_SIGN_IN_EMAIL_LINK_PATH,
      body: {
        email,
        returnUrl,
        data,
      },
    });

    responseData = response.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const sendEmailVerification = async ({
  returnUrl,
}) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: SEND_EMAIL_VERIFICATION_PATH,
      body: {
        data: {
          returnUrl,
        },
      },
    });

    responseData = response.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const sendPasswordResetEmail = async ({
  email,
  returnUrl,
}) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: SEND_PASSWORD_RESET_EMAIL_PATH,
      body: {
        data: {
          email,
          returnUrl,
        },
      },
    });

    responseData = response.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const forceResetPassword = async ({ password }) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: FORCE_RESET_PASSWORD_PATH,
      body: {
        data: {
          password,
        },
      },
    });

    responseData = response.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const getRedemption = async (redemptionCode) => {
  let responseData = null;
  let error = '';

  try {
    const response = await getWithRetry(
      { path: `${REDEMPTIONS_PATH}/${redemptionCode}` },
      3,
      1000,
      (resp) => !resp?.data?.labeldata,
    );

    responseData = response?.data ?? null;
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const postRedemptionCode = async ({
  id, pin, email, storeId, storeUid, fromAddress, shippingProviderId,
}) => {
  let responseData = {};
  let error = '';

  try {
    // No client-side retry here: registering a redemption is non-idempotent
    // (each call re-runs label generation), and the backend already retries
    // transient EasyPost "No rates found" failures. Retrying here as well
    // compounded the wait time and risked duplicate redemptions.
    const response = await post({
      path: REDEMPTIONS_PATH,
      body: {
        data: {
          id,
          pin,
          email,
          storeId,
          storeUid,
          fromAddress,
          shippingProviderId,
        },
      },
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

// Multi-bag registration: one shared address + carrier for every code.
// POST /redemptions/bulk reads its fields off the body itself (no `data`
// envelope, unlike POST /redemptions). Labels are generated asynchronously, so
// a 200 means "queued" — see parseBulkRedemptionResponse for its three shapes.
// No client-side retry, for the same non-idempotency reason as above.
const postBulkRedemption = async ({
  redemptionCodes, email, fromAddress, shippingProviderId, recyclingProductType,
}) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: REDEMPTIONS_BULK_CREATE_PATH,
      body: {
        redemptionCodes,
        email,
        fromAddress,
        shippingProviderId,
        recyclingProductType,
      },
    });

    responseData = response?.data ?? {};
  } catch (err) {
    // Keep the HTTP status (apiFetch spreads the response envelope, whose
    // `status` it is; a network failure has none): the caller needs to know
    // whether the request could have reached the server.
    error = { ...checkResponseError(err), status: err?.status };
  }

  return { data: responseData, error };
};

// GET /redemptions/validate/:code — a bag's state before it joins a batch.
const getRedemptionValidation = async (code) => {
  let responseData = null;
  let error = '';

  try {
    const response = await get({ path: `${REDEMPTIONS_VALIDATE_PATH}/${encodeURIComponent(code)}` });
    responseData = response?.data ?? null;
  } catch (err) {
    // apiFetch throws `{ error: true, ...body }` without the status, so
    // checkResponseError can't read it. Keep the API's own message: the route is
    // rate-limited (429 `{ error: 'Too many requests…' }`), and "try again"
    // copy would send the user straight back into the limit.
    error = {
      message: (typeof err?.error === 'string' && err.error) || err?.message || getGenericError(),
    };
  }

  return { data: responseData, error };
};

const fetchWithRetry = (url, tries = 3) => (
  fetch(url)
    .then(response => {
      if (response.ok) {
        return response.json();
      }

      return Promise.reject(response);
    })
    .catch(error => {
      if (tries < 1) {
        return { error };
      }

      return wait(500).then(() => fetchWithRetry(url, tries - 1));
    })
);

const AI_API_BASE = isProd()
  ? 'https://api.ia.trashie.io/api/v1'
  : 'https://api.ia.dev.trashie.io/api/v1';

const searchDeals = async ({
  q,
  limit,
  itemsPerBrand,
  affiliateCid,
  userSegments,
  isMember,
} = {}) => {
  let responseData = { items: [], total_brands: 0 };
  let error = '';

  const params = new URLSearchParams({ q });
  if (limit != null) params.append('limit', limit);
  if (itemsPerBrand != null) params.append('items_per_brand', itemsPerBrand);
  if (affiliateCid) params.append('affiliate_cid', affiliateCid);
  if (userSegments) params.append('user_segments', userSegments);
  if (isMember != null) params.append('is_member', isMember);

  try {
    const result = await fetchWithRetry(`${AI_API_BASE}/search/?${params}`);
    if (result?.error) {
      error = checkResponseError(result.error);
    } else {
      responseData = result?.result ?? responseData;
    }
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const fetchShippingProviderLocations = async ({
  URL,
  distance,
  zipcode,
  retailer,
  address,
  limit = 3,
}) => {
  let data = [];
  let error = '';

  if (!URL) {
    return {
      data,
      error,
    };
  }

  const searchParams = new URLSearchParams({
    distance,
    zipcode,
    retailer,
    address,
  });

  const result = await fetchWithRetry(`${URL}?${searchParams}`);

  if (result.error) {
    error = checkResponseError(result.error);
  } else {
    data = (result.locations ?? []).splice(0, limit);
  }

  return {
    data,
    error,
  };
};

// FedEx and FedEx Ground share one request/response contract; only the path differs.
const postFedexLocations = async (path, {
  address,
  distance,
}) => {
  let responseData = {};
  let error = '';
  try {
    const body = {
      distance: {
        units: 'MI',
        value: distance,
      },
      location: {
        address: {
          streetLines: [address.address1],
          city: address.city,
          stateOrProvinceCode: address.provinceCode,
          postalCode: address.zip,
          countryCode: US_COUNTRY_CODE,
        },
      },
    };
    const response = await post({
      path,
      body,
    });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const getFedexLocations = (args) => postFedexLocations(FEDEX_LOCATIONS_PATH, args);

const getFedexGroundLocations = (args) => (
  postFedexLocations(FEDEX_GROUND_LOCATIONS_PATH, args)
);

// Both drop-off networks take the same body on the same contract; only the path
// differs. Kept as one fetcher so a change to the address shape cannot land on one
// provider and not the other — they render through the same components.
const postDropOffNetworkLocations = async (path, { address = {}, distance }) => {
  let responseData = {};
  let error = '';
  try {
    const body = {
      customerAddress: {
        zip: address.zip,
        ...(address.address1 && { address: address.address1 }),
        ...(address.city && { city: address.city }),
        ...(address.provinceCode && { state: address.provinceCode }),
      },
      ...(distance && { maxDistance: distance }),
    };
    const response = await post({ path, body });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const getTheReturnLocations = (args) => (
  postDropOffNetworkLocations(THE_RETURN_LOCATIONS_PATH, args)
);

const getAmazonShippingLocations = (args) => (
  postDropOffNetworkLocations(AMAZON_SHIPPING_LOCATIONS_PATH, args)
);

// GoLocker banks + live availability: `{ radiusMiles, allFull, locations[] }`, each
// location carrying `availability`. Same body as /the-return, but never a
// `maxDistance` — the server applies GoLocker's own radius so the map lists exactly
// the banks the shipping-options card counted.
const getGoLockerLocations = ({ address } = {}) => (
  postDropOffNetworkLocations(GOLOCKER_LOCATIONS_PATH, { address })
);

const getTakeBackBagDetails = async (registerCode) => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({
      path: `/redemptions/${registerCode}`,
    });
    if (response.error) {
      error = response.error;
    }
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }
  return { data: responseData, error };
};

// Returns { count, result[], hasMore }. Each result is a batch/single shipping
// label grouping (type, batchId, labelCount, batchStatus, carrierLogoUrl, items[]).
// `category` ('instant' | 'physical') filters the list to the split screens;
// omit it for the unsplit home/recent view (backend returns everything).
const getShippingLabels = async ({ list, page = 1, pageSize = 10, category }) => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({
      path: TBB_SHIPPING_LABELS_PATH,
      params: { list, page, pageSize, ...(category ? { category } : {}) },
    });
    if (response.error) {
      error = response.error;
    }
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }
  return { data: responseData, error };
};

// "Get my labels" carousel — assigned-but-unregistered virtual/BYO boxes.
// Returns { count, result[], hasMore }; `count` is the TRUE total (badge), not the
// page size. Each result is a flat entry: { code, id, recyclingProductTypeId, createdAt }.
const getAvailableInstantLabels = async ({ page = 1, pageSize = 10 } = {}) => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({
      path: TBB_INSTANT_LABELS_AVAILABLE_PATH,
      params: { page, pageSize },
    });
    if (response.error) {
      error = response.error;
    }
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }
  return { data: responseData, error };
};

// Single batch (with items[]) by batchId — backs the batch-detail screen.
const getBulkShippingLabel = async (batchId) => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({
      path: REDEMPTIONS_BULK_PATH.replace(BATCH_ID_PARAM, batchId),
    });
    if (response.error) {
      error = response.error;
    }
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }
  return { data: responseData, error };
};

// Retries generation of a single failed item within a batch (batch-detail screen).
// POST /redemptions/bulk/:batchId/items/:itemId/retry — backend re-queues the item.
const postBulkShippingLabelItemRetry = async ({ batchId, itemId }) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: REDEMPTIONS_BULK_ITEM_RETRY_PATH
        .replace(BATCH_ID_PARAM, batchId)
        .replace(ITEM_ID_PARAM, itemId),
    });
    if (response.error) {
      error = response.error;
    }
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }
  return { data: responseData, error };
};

// Bulk wallet passes for a batch of shipping labels (up to 50 redemptionIds).
const postShippingLabelsWalletPassesBulk = async ({ redemptionIds, platform }) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: SHIPPING_LABELS_WALLET_PASSES_BULK_PATH,
      body: { redemptionIds, platform },
    });
    if (response.error) {
      error = response.error;
    }
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }
  return { data: responseData, error };
};

const getGiftCardsCategories = async ({ ...filters }) => {
  let responseData = {};
  let error = '';
  try {
    const response = await get({
      path: GIFT_CARDS_CATEGORIES_PATH,
      params: {
        ...filters,
      },
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

// GIFT_CARDS_BRAND_SEARCH_PATH
const getGiftCardsBrandsByName = async (name) => {
  let responseData = [];
  let error = '';

  try {
    const response = await get({
      path: GIFT_CARDS_BRAND_SEARCH_PATH,
      params: {
        name,
      },
    });

    responseData = response?.data?.brands ?? [];
  } catch (err) {
    error = checkResponseError(err);
  }
  return {
    data: responseData,
    error,
  };
};

const getGiftCardsBrands = async ({ pageSize, page, ...rest }) => {
  let responseData = [];
  let error = '';

  try {
    const response = await get({
      path: GIFT_CARDS_BRANDS_PATH,
      params: {
        pageSize,
        page,
        ...rest,
      },
    });

    responseData = response?.data ?? [];
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const getGiftCardsBrandsOffer = async ({ pageSize, page, ...rest }) => {
  let responseData = [];
  let error = '';

  try {
    const response = await get({
      path: GIFT_CARDS_BRANDS_OFFER_PATH,
      params: {
        pageSize,
        page,
        ...rest,
      },
    });

    responseData = response?.data ?? [];
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const getGiftCardBrand = async (brandId) => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({
      path: GIFT_CARDS_BRAND_PATH.replace(BRAND_ID_PARAM, brandId),
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const issueGiftCard = async ({
  brand,
  amount,
  stepUpToken,
}) => {
  let responseData = {};
  let error = null;

  try {
    const response = await post({
      path: GIFT_CARDS_ISSUE_PATH,
      body: { brand, amount, stepUpToken },
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const getGiftCardByUid = async (giftCardId) => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({
      path: GIFT_CARD_BY_UID_PATH.replace(GIFT_CARD_ID_PARAM, giftCardId),
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const getUserGiftCards = async ({
  pageSize,
  page,
  orderBy,
  orderType,
  status,
  isUsed,
}) => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({
      path: GIFT_CARDS_USER_PATH,
      params: {
        pageSize,
        page,
        orderBy,
        orderType,
        status,
        isUsed,
      },
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

export const getGiftCardWalletPass = async (orderId, platform) => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({
      path: GIFT_CARDS_WALLET_PASS_PATH.replace(GIFT_CARD_ID_PARAM, orderId),
      params: { platform },
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const getSystemMessages = async () => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({
      path: SYSTEM_MESSAGES_PATH,
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const TRASHIE_GA_MEASUREMENT_ID = isProd()
  ? TRASHIE_GA_TAG_ID.PRODUCTION
  : TRASHIE_GA_TAG_ID.STAGING;

const getGa4ScopedCookiePrefix = () => `_ga_${TRASHIE_GA_MEASUREMENT_ID.replace(/^G-/, '')}`;

const getClientIdFromCookie = () => {
  try {
    if (typeof document === 'undefined') return null;
    const match = document.cookie.match(
      /(?:^|;\s*)_ga=(?:GA1|GS1|GS2)\.\d+\.(.+?)(?:;|$)/,
    );
    return match ? match[1] : null;
  } catch {
    return null;
  }
};

const getSessionIdFromCookie = () => {
  try {
    if (typeof document === 'undefined') return null;
    const prefix = getGa4ScopedCookiePrefix();
    const escaped = prefix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const raw = document.cookie.match(
      new RegExp(`(?:^|;\\s*)${escaped}=([^;]+)`),
    );
    if (!raw) return null;
    const val = raw[1];
    // GS2 format: GS2.1.s<session_id>$o1$g0...
    const gs2Match = val.match(/^GS2\.\d+\.s(\d+)/);
    if (gs2Match) return gs2Match[1];
    // GS1 format: GS1.1.<session_id>.<count>...
    const gs1Match = val.match(/^GS1\.\d+\.(\d+)/);
    if (gs1Match) return gs1Match[1];
    return null;
  } catch {
    return null;
  }
};

const getSearchParamValue = (searchParams, key) => {
  if (!searchParams) return null;
  if (typeof searchParams.get === 'function') {
    return searchParams.get(key);
  }
  return searchParams[key] || null;
};

/** Single gtag read when cookies are missing (until server reads cookies on API). */
const getGaFieldFromGtagFallback = (field) => new Promise((resolve) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    resolve(null);
    return;
  }
  const timeoutMs = 500;
  const timeout = setTimeout(() => resolve(null), timeoutMs);
  window.gtag('get', TRASHIE_GA_MEASUREMENT_ID, field, (val) => {
    clearTimeout(timeout);
    resolve(val ? String(val) : null);
  });
});

const getGaClientId = async () => {
  const cookieVal = getClientIdFromCookie();
  if (cookieVal) return String(cookieVal);
  return getGaFieldFromGtagFallback('client_id');
};

const getGaSessionId = async () => {
  const cookieVal = getSessionIdFromCookie();
  if (cookieVal) return String(cookieVal);
  return getGaFieldFromGtagFallback('session_id');
};

const getCookieValue = (name) => {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]+)`));
  if (!match?.[1]) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
};

const buildCheckoutAttributionPayload = async (searchParams) => {
  const storedUtms = getStoredUtms() || {};
  const getAttribution = (key) => getSearchParamValue(searchParams, key) || storedUtms[key] || null;

  // First touch is read from its own store, never from searchParams: the URL
  // reflects the CURRENT arrival, which is exactly what would overwrite it.
  const firstTouch = getFirstTouchAttribution() || {};
  const getFirstTouch = (key) => firstTouch[key] || null;

  const payload = {
    gaClientId: await getGaClientId(),
    gaSessionId: await getGaSessionId(),
    utmSource: getAttribution('utm_source'),
    utmMedium: getAttribution('utm_medium'),
    utmCampaign: getAttribution('utm_campaign'),
    utmTerm: getAttribution('utm_term'),
    utmContent: getAttribution('utm_content'),
    gclid: getAttribution('gclid'),
    fbclid: getAttribution('fbclid'),
    msclkid: getAttribution('msclkid'),
    ttclid: getAttribution('ttclid'),
    gbraid: getAttribution('gbraid'),
    wbraid: getAttribution('wbraid'),
    fbc: getCookieValue('_fbc'),
    fbp: getCookieValue('_fbp'),
    irclickid: getAttribution('irclickid'),
    // First-touch attribution — the campaign that ACQUIRED this customer, as
    // opposed to the fields above, which carry the most recent campaign. Sent
    // under distinct keys so the existing last-touch reporting is unaffected.
    firstUtmSource: getFirstTouch('utm_source'),
    firstUtmMedium: getFirstTouch('utm_medium'),
    firstUtmCampaign: getFirstTouch('utm_campaign'),
    firstUtmTerm: getFirstTouch('utm_term'),
    firstUtmContent: getFirstTouch('utm_content'),
    firstFbclid: getFirstTouch('fbclid'),
    firstGclid: getFirstTouch('gclid'),
    firstLandingPage: getFirstTouch('landing_page'),
    // Partnership Referral partner id (the partner's `stores.id`) — captured
    // from /unlimited?partner=<id> and persisted in the partner_ref cookie.
    // Read server-side at checkout creation to resolve the per-partner Shopify
    // discount code and to attach partner identity to the Shopify cart
    // attributes (which the subscription webhook uses to write the
    // partnersMembershipReferrals row).
    partnerId: getStoredPartnerRef(),
    // Membership Referral code captured from /unlimited?ref=<code> and persisted
    // in sessionStorage. Read server-side at checkout creation to attribute the
    // subscription to the referrer (omitted automatically when absent).
    referralCode: getStoredReferralCode(),
  };

  return Object.fromEntries(
    Object.entries(payload).filter(([, value]) => value !== null && value !== ''),
  );
};

const createPayOnRegCheckoutSession = async (
  redemptionCode,
  couponId = null,
  productType = null,
  searchParams = null,
) => {
  let responseData = {};
  let error = '';
  const serializedSearchParams = serializeSearchParams(searchParams);

  try {
    const attributionData = await buildCheckoutAttributionPayload(searchParams);
    const response = await post({
      path: PAYMENTS_CREATE_PAY_ON_REG_CHECKOUT_SESSION_PATH
        .replace(REDEMPTION_CODE_PARAM, redemptionCode),
      body: {
        couponId,
        ...(productType && { productType }),
        ...(serializedSearchParams && { searchParams: serializedSearchParams }),
        ...attributionData,
      },
    });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const getCheckoutSession = async (checkoutSessionId) => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({
      path: SUBSCRIPTIONS_CHECKOUT_SESSION_PATH.replace(
        CHECKOUT_SESSION_ID_PARAM,
        checkoutSessionId,
      ),
    });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const getOrderCheckoutSession = async (checkoutSessionId) => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({
      path: PAYMENTS_ORDER_CHECKOUT_SESSION_PATH.replace(
        CHECKOUT_SESSION_ID_PARAM,
        checkoutSessionId,
      ),
    });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const createPaymentIntent = async (redemptionCode) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: PAYMENTS_CREATE_PAYMENT_INTENT_PATH.replace(REDEMPTION_CODE_PARAM, redemptionCode),
    });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const getPaymentStatus = async (redemptionCode, retry = false) => {
  let responseData = {};
  let error = '';

  const path = PAYMENTS_STATUS_PATH.replace(REDEMPTION_CODE_PARAM, redemptionCode);

  try {
    const response = retry
      ? await getWithRetry(
        { path },
        3,
        2000,
        (resp) => resp.data?.isPayOnShip === true && resp.data?.isPaid === false,
      )
      : await get({ path });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const createSubscriptionCheckoutSession = async ({
  products,
  address,
  couponId,
  isDirectPayment,
  searchParams,
}) => {
  let responseData = {};
  let error = '';
  const serializedSearchParams = serializeSearchParams(searchParams);

  try {
    const attributionData = await buildCheckoutAttributionPayload(searchParams);
    const response = await post({
      path: SUBSCRIPTIONS_CREATE_CHECKOUT_SESSION_PATH,
      body: {
        products,
        shippingAddress: address,
        couponId,
        isDirectPayment,
        ...(serializedSearchParams && { searchParams: serializedSearchParams }),
        ...attributionData,
      },
    });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const createShopifyCheckoutSession = async ({
  products,
  address,
  discountCode,
  isDirectPayment,
  returnPath,
  searchParams,
  includesToyBox,
  email,
  shippingCode,
  initiateCheckoutEventId,
  renewal,
}) => {
  let responseData = {};
  let error = '';
  const serializedSearchParams = serializeSearchParams(searchParams);

  try {
    const attributionData = await buildCheckoutAttributionPayload(searchParams);
    const response = await post({
      path: SUBSCRIPTIONS_CREATE_SHOPIFY_CHECKOUT_PATH,
      body: {
        products,
        shippingAddress: address,
        discountCode,
        isDirectPayment,
        returnPath,
        // Pre-fills the buyer's email on the Shopify checkout page; the backend
        // also uses it to block a duplicate membership purchase.
        ...(email && { email }),
        // The in-app shipping tier the buyer picked. The backend stamps it as a
        // line-item property so the carrier callback narrows hosted checkout to
        // just that option.
        ...(shippingCode && { shippingCode }),
        // Strict boolean — backend rejects truthy-non-true to avoid silent activation.
        ...(includesToyBox === true && { includesToyBox: true }),
        ...(serializedSearchParams && { searchParams: serializedSearchParams }),
        // Shared with the browser fbq InitiateCheckout so Meta can deduplicate
        // the pair rather than counting both.
        ...(initiateCheckoutEventId && { initiateCheckoutEventId }),
        // A lapsed member renewing from the app: the backend renews them on their
        // previous plan with no starter kit (and attaches their win-back code).
        ...(renewal === true && { renewal: true }),
        ...attributionData,
      },
    });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

// Pre-checkout guard: does this email already have an active membership? Public
// (guest-callable) + rate-limited on the backend. Returns { hasActiveMembership }.
const getMembershipStatus = async (email) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: SUBSCRIPTIONS_MEMBERSHIP_STATUS_PATH,
      body: { email },
    });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const createToyBoxUpgradeCheckoutSession = async () => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: SUBSCRIPTIONS_TOY_BOX_UPGRADE_CHECKOUT_PATH,
      body: {},
    });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

// Membership paid shipping-fee: create a draft-order checkout for the selected
// tier. Returns { checkoutUrl, ref, feeCents, shippingTitle }.
const createMembershipShippingCheckout = async ({
  products,
  userAddressId,
  shippingCode,
  checkoutMode,
}) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: SUBSCRIPTIONS_MEMBERSHIP_SHIPPING_CHECKOUT_PATH,
      body: {
        products,
        userAddressId,
        shippingCode,
        checkoutMode,
        // Lets the backend return to localhost during local dev — it only
        // honors localhost origins, so qa/staging/prod use the canonical URL.
        appOrigin:
          (typeof window !== 'undefined' && window.location?.origin) || undefined,
      },
    });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

// Record a user-initiated cancellation of the shipping-fee popup checkout (the
// modal's "I closed the checkout" button — popup flow only). Best-effort: the UI
// resolves cancel locally, this just updates the backend ledger. Payment always
// wins server-side (never overwrites a completed row).
const cancelMembershipShippingCheckout = async (ref) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: SUBSCRIPTIONS_MEMBERSHIP_SHIPPING_CANCEL_PATH,
      body: { ref },
    });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

// Poll target while the shipping-fee popup is open: { status: 'pending' |
// 'completed', shopifyOrderId?, shippingCode? } for a given checkout ref.
const getMembershipShippingCheckoutStatus = async (ref) => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({
      path: SUBSCRIPTIONS_MEMBERSHIP_SHIPPING_STATUS_PATH,
      params: { ref },
    });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const getPaymentMethodUpdateUrl = async (subscriptionId) => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({
      path: SUBSCRIPTIONS_UPDATE_PAYMENT_URL_PATH.replace(
        SUBSCRIPTION_ID_PARAM,
        subscriptionId,
      ),
    });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const updateMembershipSubscription = async (subscriptionId, defaultPaymentMethod) => {
  let responseData = {};
  let error = '';

  try {
    const response = await patch({
      path: SUBSCRIPTIONS_UPDATE_PATH.replace(SUBSCRIPTION_ID_PARAM, subscriptionId),
      body: {
        defaultPaymentMethod,
      },
    });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const createSetupIntent = async () => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: PAYMENTS_CREATE_SETUP_INTENT_PATH,
    });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const createOrderCheckoutSession = async ({
  products,
  userAddressId,
  shippingAddress,
  shippingPrice,
  searchParams,
}) => {
  let responseData = {};
  let error = '';
  const serializedSearchParams = serializeSearchParams(searchParams);

  try {
    const attributionData = await buildCheckoutAttributionPayload(searchParams);
    const response = await post({
      path: PAYMENTS_ORDER_CREATE_CHECKOUT_SESSION_PATH,
      body: {
        products,
        userAddressId,
        shippingAddress,
        shippingPrice,
        ...(serializedSearchParams && { searchParams: serializedSearchParams }),
        ...attributionData,
      },
    });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const validateShipping = async ({ type, products, shippingAddress }) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: MEMBERSHIP_VALIDATE_SHIPPING_PATH,
      // `shippingAddress` is optional — membership rates are flat per-SKU, so the
      // signup previews them with no address (territory rules are enforced at
      // hosted checkout with the real address).
      body: {
        type,
        products,
        ...(shippingAddress && { shippingAddress }),
      },
    });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const getRewardsExclusive = async ({ redemptionCode, pageSize, page, ...rest }) => {
  let responseData = [];
  let error = '';

  try {
    const response = await get({
      path: REWARDS_EXCLUSIVE_PATH.replace(REDEMPTION_CODE_PARAM, redemptionCode),
      params: {
        pageSize,
        page,
        ...rest,
      },
    });

    responseData = response?.data ?? [];
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const getRemainingBrownTickets = async () => {
  let responseData;
  let error = '';

  try {
    const res = await get({
      path: EVENT_TICKETS_COUNT_PATH.replace(EVENT_ID_PARAM, BROWN_UNIVERSITY_EVENT_ID),
    });

    responseData = res.data;
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const signUpUserToBrownCampaign = async ({ holderEmail, holderDetails }) => {
  let responseData;
  let error = '';

  try {
    const res = await post({
      path: EVENT_TICKETS_CLAIM_PATH.replace(EVENT_ID_PARAM, BROWN_UNIVERSITY_EVENT_ID),
      body: { holderEmail, holderDetails },
    });

    responseData = res.data;
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const subscribeUserToIterableList = async ({ listId, email, firstName, lastName, address }) => {
  let responseData;
  let error = '';

  try {
    const res = await post({
      path: MARKETING_ITERABLE_SUBSCRIPTION_PATH,
      body: { listId, email, firstName, lastName, ...address },
    });

    responseData = res.data;
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const getSubscriptionsOrders = async ({ page, pageSize, from } = {}) => {
  let data = {};
  let error = '';

  try {
    const response = await get({
      path: SUBSCRIPTIONS_ORDERS_PATH,
      // `from` only when set — URLSearchParams would send the string "undefined".
      params: { page, pageSize, ...(from && { from }) },
    });

    data = response.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data, error };
};

const getSubscriptionsOrdersSummary = async ({ from } = {}) => {
  let data = {};
  let error = '';

  try {
    const response = await get({
      path: SUBSCRIPTIONS_ORDERS_SUMMARY_PATH,
      params: from ? { from } : {},
    });

    data = response.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data, error };
};

const getMembershipSubscription = async () => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({ path: SUBSCRIPTIONS_PATH });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const getMembershipAddresses = async ({ pageSize = 2 }) => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({
      path: `${USERS_MEMBERSHIP_ADDRESSES_PATH}?pageSize=${pageSize}`,
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const getMembershipProductsPrices = async () => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({
      path: MEMBERSHIP_PRODUCTS_PRICES_PATH,
    });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

// Partnership Referral — fetch a partner's public config by its stores.id.
// `includePricing` opts into the discounted-price computation (used by the
// /unlimited summary); omit it for branding-only reads so landing pages don't
// trigger the Shopify discount lookup. See api-fordays-cloud TRA-224.
const getPartner = async (partnerId, { includePricing = false } = {}) => {
  let responseData = null;
  let error = '';

  try {
    const response = await get({
      path: PARTNER_PATH.replace(PARTNER_ID_PARAM, encodeURIComponent(partnerId)),
      ...(includePricing ? { params: { includePricing: 'true' } } : {}),
    });
    responseData = response?.data ?? null;
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const createUserAddress = async ({ fromAddress }) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: USERS_CREATE_ADDRESS_PATH,
      body: {
        data: {
          fromAddress,
        },
      },
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const updateUserAddress = async ({ addressUid, fromAddress }) => {
  let responseData = {};
  let error = '';

  try {
    const response = await patch({
      path: USERS_UPDATE_ADDRESS_PATH.replace(ADDRESS_UID_PARAM, addressUid),
      body: {
        data: {
          fromAddress,
        },
      },
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const placeSubscriptionOrder = async ({ products, userAddressId, address, shippingCode }) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: SUBSCRIPTIONS_CLAIM_TBB_PATH,
      body: {
        products,
        shippingAddress: address,
        userAddressId,
        // Carries the selected tier so the claim ships that method. Omitted →
        // default (Economy).
        ...(shippingCode && { shippingCode }),
      },
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const cancelMembershipRenewalSubscription = async ({ subscriptionId, cancelAtPeriodEnd, cancellationComment = '' }) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: SUBSCRIPTIONS_CANCEL_PATH.replace(SUBSCRIPTION_ID_PARAM, subscriptionId),
      body: { cancelAtPeriodEnd, cancellationComment },
    });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

// Renewal state the in-app messaging renders from (grace period, pre-expiry,
// lapsed) plus its offer. Unlike getMembershipSubscription this answers for a
// lapsed member too, so `{ state: 'NONE' }` is a valid, non-error result.
const getMembershipRenewalStatus = async () => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({ path: SUBSCRIPTIONS_RENEWAL_STATUS_PATH });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

// Whether a lapsed Stripe member's Renew can charge the card Stripe already holds,
// and what the confirmation sheet shows (card, price with offer and tax).
// `eligible: false` means: use the Shopify renewal checkout as before.
const getStripeWinbackQuote = async () => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({ path: SUBSCRIPTIONS_WINBACK_STRIPE_QUOTE_PATH });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

// Renews a lapsed Stripe member on their saved card. Answers `{ status,
// shopifyFallback, ... }` like the card-update retry. Never retried by callers: it
// charges the card.
const renewOnSavedStripeCard = async () => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({ path: SUBSCRIPTIONS_WINBACK_STRIPE_RENEW_PATH, body: {} });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

// Turns auto-renewal back on for a membership set to end, applying the resume
// offer when one is configured. Never retried by callers: it is a billing write.
const resumeMembershipAutoRenew = async (subscriptionId) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: SUBSCRIPTIONS_RESUME_AUTO_RENEW_PATH.replace(SUBSCRIPTION_ID_PARAM, subscriptionId),
      body: {},
    });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

/**
 * The save offer for the last step of the cancel-auto-renewal flow. `offer` is null
 * when there is none to show.
 *
 * @param {string} subscriptionId
 * @return {Promise<{data: object, error: string}>}
 */
const getMembershipSaveOffer = async (subscriptionId) => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({
      path: SUBSCRIPTIONS_SAVE_OFFER_PATH.replace(SUBSCRIPTION_ID_PARAM, subscriptionId),
    });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

/**
 * Keep auto-renewal on with the save offer applied to the next renewal.
 *
 * @param {string} subscriptionId
 * @return {Promise<{data: object, error: string}>}
 */
const acceptMembershipSaveOffer = async (subscriptionId) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: SUBSCRIPTIONS_ACCEPT_SAVE_OFFER_PATH.replace(SUBSCRIPTION_ID_PARAM, subscriptionId),
      body: {},
    });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const getSubscriptionSavedMoney = async () => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({ path: SAVED_MONEY_PATH });
    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const getSubscriptionsPlans = async () => {
  let responseData = {};
  let error = '';

  try {
    const response = await get({ path: SUBSCRIPTIONS_PLANS_PATH });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return {
    data: responseData,
    error,
  };
};

const postRegisterPhone = async ({
  phoneNumber, countryCode, emailCode, authToken,
}) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: AUTH_PHONE_PATH,
      body: { phoneNumber, countryCode, emailCode },
      authToken,
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const postPhoneVerify = async ({ idToken, authToken }) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: AUTH_PHONE_VERIFY_PATH,
      body: { idToken },
      authToken,
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const postMfaEnable = async ({ authToken } = {}) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: AUTH_MFA_ENABLE_PATH,
      authToken,
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const postSecurityCode = async ({ authToken } = {}) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: AUTH_SECURITY_CODE_PATH,
      body: {},
      authToken,
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const postMfaStepUp = async ({ phoneIdToken }) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: AUTH_MFA_STEP_UP_PATH,
      body: { phoneIdToken },
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

const postPhoneLogin = async ({ idToken }) => {
  let responseData = {};
  let error = '';

  try {
    const response = await post({
      path: AUTH_PHONE_LOGIN_PATH,
      body: { idToken },
    });

    responseData = response?.data ?? {};
  } catch (err) {
    error = checkResponseError(err);
  }

  return { data: responseData, error };
};

export {
  getUser,
  getSummary,
  getTransactions,
  sendEventStream,
  syncUser,
  createOrFetchUser,
  getSustainabilityImpactUser,
  getRewards,
  getUserRewards,
  getUserAddresses,
  getMilestoneProgress,
  getReferralDashboard,
  getUserStatus,
  getStoreRewards,
  patchReward,
  patchRewardCodeIsUsed,
  getStore,
  getRewardsOffer,
  getRewardsPaidPlacements,
  getConfigurations,
  getCCDiscountCodes,
  postCCDiscountCode,
  postShippingLabelRegenerate,
  getCategories,
  getEarningsCarousel,
  sendSignInEmailLink,
  sendEmailVerification,
  sendPasswordResetEmail,
  forceResetPassword,
  fetchShippingProviders,
  postSubscribeStatus,
  getRedemption,
  postRedemptionCode,
  postBulkRedemption,
  getRedemptionValidation,
  fetchShippingProviderLocations,
  getTakeBackBagDetails,
  getShippingLabels,
  getAvailableInstantLabels,
  getBulkShippingLabel,
  postShippingLabelsWalletPassesBulk,
  postBulkShippingLabelItemRetry,
  getGiftCardsCategories,
  getGiftCardsBrands,
  getGiftCardsBrandsOffer,
  getGiftCardsBrandsByName,
  getGiftCardBrand,
  issueGiftCard,
  getGiftCardByUid,
  getUserGiftCards,
  patchGiftCardsIsUsed,
  getSimilarAndTrendingRewards,
  getFeaturedRewards,
  getSystemMessages,
  createPayOnRegCheckoutSession,
  getCheckoutSession,
  getOrderCheckoutSession,
  getPaymentStatus,
  createSubscriptionCheckoutSession,
  createShopifyCheckoutSession,
  getMembershipStatus,
  createToyBoxUpgradeCheckoutSession,
  createMembershipShippingCheckout,
  getMembershipShippingCheckoutStatus,
  cancelMembershipShippingCheckout,
  getPaymentMethodUpdateUrl,
  createSetupIntent,
  createOrderCheckoutSession,
  getRewardsExclusive,
  getUserExclusiveDeals,
  getRemainingBrownTickets,
  signUpUserToBrownCampaign,
  subscribeUserToIterableList,
  getMembershipAddresses,
  createUserAddress,
  updateUserAddress,
  placeSubscriptionOrder,
  getSubscriptionsOrders,
  getSubscriptionsOrdersSummary,
  getMembershipSubscription,
  getMembershipRenewalStatus,
  getStripeWinbackQuote,
  renewOnSavedStripeCard,
  resumeMembershipAutoRenew,
  getMembershipSaveOffer,
  acceptMembershipSaveOffer,
  cancelMembershipRenewalSubscription,
  updateMembershipSubscription,
  getMembershipProductsPrices,
  getPartner,
  getSubscriptionSavedMoney,
  createPaymentIntent,
  validateShipping,
  getSubscriptionsPlans,
  getFedexLocations,
  getFedexGroundLocations,
  getTheReturnLocations,
  getGoLockerLocations,
  getAmazonShippingLocations,
  postRegisterPhone,
  postPhoneVerify,
  postMfaEnable,
  postSecurityCode,
  postMfaStepUp,
  postPhoneLogin,
  updateUser,
  searchDeals,
};
